// Sound engine: existing mp3 stingers + WebAudio-synthesized SFX (no extra assets needed).

let ctx = null;
let muted = false;

function ac() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

export function setMuted(m) {
  muted = m;
}

export function isMuted() {
  return muted;
}

// Unlock audio on first user gesture (browsers block autoplay).
export function unlockAudio() {
  ac();
}

function playFile(path, volume = 1) {
  if (muted) return;
  const audio = new Audio(path);
  audio.volume = volume;
  audio.play().catch(() => {});
}

function tone({ freq = 440, end = freq, time = 0.15, type = "sine", vol = 0.2, when = 0 }) {
  const c = ac();
  if (!c || muted) return;
  const o = c.createOscillator();
  const g = c.createGain();
  const t0 = c.currentTime + when;
  o.type = type;
  o.frequency.setValueAtTime(freq, t0);
  o.frequency.exponentialRampToValueAtTime(Math.max(1, end), t0 + time);
  g.gain.setValueAtTime(vol, t0);
  g.gain.exponentialRampToValueAtTime(0.001, t0 + time);
  o.connect(g).connect(c.destination);
  o.start(t0);
  o.stop(t0 + time + 0.05);
}

function noise({ time = 0.2, vol = 0.15, freq = 1200, when = 0 }) {
  const c = ac();
  if (!c || muted) return;
  const len = Math.floor(c.sampleRate * time);
  const buf = c.createBuffer(1, len, c.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / len);
  const src = c.createBufferSource();
  src.buffer = buf;
  const f = c.createBiquadFilter();
  f.type = "bandpass";
  f.frequency.value = freq;
  const g = c.createGain();
  g.gain.value = vol;
  src.connect(f).connect(g).connect(c.destination);
  src.start(c.currentTime + when);
}

export const sfx = {
  // Existing recorded stingers
  correct: () => playFile("/sound/correct.mp3", 0.9),
  keyAnswer: () => playFile("/sound/key_ans.mp3", 1),
  alreadyGiven: () => playFile("/sound/already_given.mp3", 0.8),

  // Synthesized
  wrong: () => {
    tone({ freq: 180, end: 90, time: 0.35, type: "sawtooth", vol: 0.22 });
    tone({ freq: 120, end: 60, time: 0.35, type: "square", vol: 0.12 });
  },
  whoosh: () => noise({ time: 0.3, vol: 0.2, freq: 900 }),
  pop: () => tone({ freq: 520, end: 900, time: 0.09, type: "triangle", vol: 0.25 }),
  join: () => {
    tone({ freq: 440, end: 660, time: 0.1, type: "triangle", vol: 0.2 });
    tone({ freq: 660, end: 880, time: 0.12, type: "triangle", vol: 0.2, when: 0.1 });
  },
  tick: () => tone({ freq: 900, end: 900, time: 0.05, type: "square", vol: 0.08 }),
  flip: () => {
    noise({ time: 0.12, vol: 0.12, freq: 2400 });
    tone({ freq: 700, end: 1200, time: 0.14, type: "sine", vol: 0.15 });
  },
  roundIntro: () => {
    tone({ freq: 330, end: 330, time: 0.14, type: "square", vol: 0.14 });
    tone({ freq: 440, end: 440, time: 0.14, type: "square", vol: 0.14, when: 0.16 });
    tone({ freq: 550, end: 550, time: 0.22, type: "square", vol: 0.16, when: 0.32 });
  },
  fanfare: () => {
    [523, 659, 784, 1046].forEach((f, i) =>
      tone({ freq: f, end: f, time: 0.35, type: "triangle", vol: 0.2, when: i * 0.18 })
    );
    noise({ time: 0.8, vol: 0.08, freq: 3000, when: 0.7 });
  },
  sad: () => {
    tone({ freq: 392, end: 392, time: 0.3, type: "sine", vol: 0.16 });
    tone({ freq: 330, end: 330, time: 0.3, type: "sine", vol: 0.16, when: 0.3 });
    tone({ freq: 262, end: 240, time: 0.6, type: "sine", vol: 0.18, when: 0.6 });
  },
};
